define([
    'text!index2024-project-info/component/page-content.html',
    'index2024-project-info/common/api',
    'jquery',
    '../common/utils',
    'inView',
    'css!index2024-project-info/component/page-content.css',
], function(
    tpl,
    Api,
    $,
    Utils,
    inView
){
    return {
        template: tpl,
        components: {

        },
        data: function(){
            return {
                atHomeIndex: 0,
                visitIndex: 0,
                atHome: [],
                visitList: [],
                isZh: true,
                isPC: true,
                info: {},
                waterList: []
            };
        },
        methods: {
            init: function(){
                var _this = this;
                if($(window).width()<=750){
                    _this.isPC = false;
                    $('.fixed-menu').css({'display': 'none'});
                }else {
                    _this.isPC = true;
                }
                if(_this.$i18n.locale=='en'){
                    _this.isZh = false;
                    // _this.fnjiIndex = _this.$i18n.messages.en.fnjiIndex;
                }else {
                    _this.isZh = true;
                    // _this.fnjiIndex = _this.$i18n.messages.zh.fnjiIndex;
                }
                var url = window.location.href;
                var queryList = url.split('?')[1].split('&');
                for(var i=0;i<queryList.length;i++){
                    if (queryList[i].split('=')[0]=='id'){
                        _this.id = queryList[i].split('=')[1];
                        return
                    }
                }
            },
            getImages: function(){
                var _this = this;
                return Api.getProjectDetailApi.ajax({id:_this.id})
                    .done(function(data){
                        _this.info = data;
                        if(data.morePics){
                            _this.waterList = data.morePics.split(';');
                            if(!_this.waterList[_this.waterList.length-1]){
                                _this.waterList.pop()
                            }
                        }
                        // _this.slickInfo();
                    });
            },
            fadeChange: function (index,num) {
                var _this = this;
                var couldRun = true;
                if(couldRun) {
                    couldRun = false;
                    if(num===0){
                        // $('#imageArtName'+index).find('.art-stage-img-fade').removeClass('hide');
                        $('#imageArtName'+index).find('.atHome-imgs-item-fade').fadeIn();
                    }else {
                        // $('#imageArtName'+index).find('.art-stage-img-fade').addClass('hide');
                        $('.imageArtName').find('.atHome-imgs-item-fade').fadeOut();
                    }
                    // 一秒后将变为可运行
                    setTimeout(function(){
                        couldRun = true;
                    },1000);
                }
            },
            initAnimate: function(){
                var selector = '.index-cell';
                inView(selector)
                    .on('enter', function(el){
                        $(el).css({
                            transform: 'translateY(0)'
                        });
                    })
                    .on('exit', function(el){
                        var rect = el.getBoundingClientRect();
                        var ty = rect.top > 0 ? 80 : -80;
                        $(el).css({
                            transform: 'translateY('+ty+'px)'
                        });
                    });
                $(selector).each(function(){
                    inView(selector).emit('exit', this);
                });
            },
            initScroll:function () {
                var obj = this;
                $(window).scroll(function(e) {
                    console.log($(document).scrollTop()+199);
                    // if(367<=$(document).scrollTop()){
                    //     obj.atHomeIndex = parseInt(($(document).scrollTop()-199)/240);
                    //     $('.atHome-scroll').css('position','fixed');
                    //     $('.atHome-scroll').css('top','-'+obj.atHomeIndex*20+'px');
                    // }else {
                    //     obj.atHomeIndex = 0;
                    //     $('.atHome-scroll').css('position','relative');
                    //     $('.atHome-scroll').css('top','');
                    // }
                    if(179<=$(document).scrollTop()){
                        $('.atHome-top').css('position','fixed');
                        $('.atHome-top').css('top','45px');
                        $('.atHome-top').css('padding-top','40px');
                        $('.atHome-top').css('z-index','100');
                        // if(199<=$(document).scrollTop()){
                        //     obj.atHomeIndex = parseInt(($(document).scrollTop()-199)/240);
                        //     $('.atHome-scroll').css('position','fixed');
                        //     $('.atHome-scroll').css('top','200px');
                        $('.atHome-scroll-in').css('position','fixed');
                        $('.atHome-scroll-in').css('top',255-obj.atHomeIndex*20+'px');
                        // $('.atHome-scroll').css('position','fixed');
                        // $('.atHome-scroll').css('top','-'+obj.atHomeIndex*20+'px');
                        // }else {
                        // $('.atHome-scroll').css('position','relative');
                        // $('.atHome-scroll').css('top','');
                        // }
                    }else {
                        obj.atHomeIndex = 0;
                        $('.atHome-top').css('position','relative');
                        $('.atHome-top').css('top','');
                        $('.atHome-top').css('padding-top','0');
                        // $('.atHome-scroll').css('position','relative');
                        // $('.atHome-scroll').css('top','');
                        $('.atHome-scroll-in').css('position','relative');
                        $('.atHome-scroll-in').css('top','');
                    }
                    if(199<=$(document).scrollTop()){
                        obj.atHomeIndex = parseInt(($(document).scrollTop()-199)/240);
                    }else {
                        obj.atHomeIndex = 0;
                    }

                });
            },
            goItem: function (index){
                var obj = this;
                obj.atHomeIndex = index;
                var theNb;
                // $(document).scrollTop(obj.atHomeIndex*240+199);
                if(index%2===1){
                    theNb = index-1;
                }else {
                    theNb = index;
                }
                $("html,body").animate({scrollTop: theNb*240+199 + "px"}, 500);
            },
            goAtHome: function (item){
                window.location.href = '/fnjihome-detail?id='+item.id;
            }
        },
        watch: {
            '$i18n.locale': function () {
                this.init();
            }
        },
        mounted: function(){

            // alert($(window).width());
            //
            // if($(window).width() > 1280)
            // {
            //     this.big = true;
            // }
            this.init();
            this.getImages();
            this.initScroll();
            // this.initAnimate();
            Utils.emitPageReady();

        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./index2024-project-info/component/page-content.js
// module id = 336
// module chunks = 19